module.exports = __webpack_public_path__ + "img/orkney-islands.1fe7288b.svg";